import { tenantRouterModel } from 'APP/model/model';
import { storage } from 'APP/packages/storage';

export async function getDeeplinkRoutingUrls(deeplink: string): Promise<boolean> {
  try {
    const urls = await tenantRouterModel.getDeepLinkRoutingUrls({ deeplink });
    if (!urls) {
      storage.tenantRouting.remove();
      return false;
    }
    storage.tenantRouting.set(urls);
    return true;
  } catch {
    storage.tenantRouting.remove();
    return false;
  }
}
